import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twentyfourseaterbusforrentinpune() {



  const cardData =
  {
    keyword: '24 Seater Bus for Rent in Pune',
    heading: 'Amruta Travels: 24 Seater Bus for Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides 24 Seater Bus for Rent in Pune, offering the perfect balance of comfort, safety, and affordability for group travel. Ideal for corporate trips, school excursions, weddings, family tours, and outstation journeys, our 24-seater buses are equipped with push-back seats, powerful air conditioning, and ample legroom for a relaxing ride. Whether you’re traveling within Pune or heading to destinations like Mumbai, Mahabaleshwar, or Shirdi, our well-maintained buses and professional chauffeurs ensure a smooth and punctual journey. Choose Amruta Travels Pvt. Ltd. for a hassle-free and premium 24 Seater Bus Rental in Pune, where comfort meets reliability for every traveler.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the royal residence of Bajirao I, it reflects the grandeur of Maratha architecture with its massive gates, fountains, and gardens. The evening light and sound show brings history to life. Shaniwar Wada remains a must-visit heritage site that tells the glorious tale of Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a symbol of India’s freedom struggle and a masterpiece of Indo-Islamic architecture. Built in 1892 by Sultan Muhammed Shah Aga Khan III, it served as a prison for Mahatma Gandhi and his wife Kasturba during the Quit India Movement. The museum inside preserves rare photos and personal belongings of Gandhi. It stands today as Pune’s monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the Sahyadri hills, is a historical fortress famous for the valor of Tanaji Malusare. The fort offers breathtaking panoramic views of the surrounding valleys and is a popular trekking destination. Ancient ruins, cannons, and the Tanaji memorial make it a must-see for history lovers. Sinhagad Fort is Pune’s majestic reminder of Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s spiritual heart, attracting devotees from across India. The temple’s beautifully adorned idol of Lord Ganesha is known for its grandeur and divine presence. During Ganesh Chaturthi, the area transforms into a dazzling festival of lights, music, and devotion. It’s a sacred landmark representing Pune’s deep-rooted faith and cultural pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a serene escape in Pune offering panoramic city views and spiritual calm. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. The 108-step climb rewards visitors with peace and stunning sunsets. Parvati Hill combines Pune’s heritage, spirituality, and scenic beauty in one tranquil experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple carved from basalt stone, dedicated to Lord Shiva. The temple’s circular Nandi mandapa and stone pillars showcase ancient Indian craftsmanship. Located in the city center, it offers a quiet retreat from urban hustle. Pataleshwar Temple stands as Pune’s timeless link to its ancient spiritual roots."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s rich cultural heritage. From antique musical instruments to intricate carvings and rare household items, it’s a treasure trove of history. Founded by Dr. D.G. Kelkar, the museum celebrates India’s artistic excellence. It’s one of Pune’s most fascinating destinations for culture enthusiasts."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global meditation center attracting visitors seeking peace and transformation. Surrounded by lush greenery and tranquil gardens, it offers meditation sessions, yoga, and wellness therapies. The ashram’s modern design and spiritual vibe create a unique experience. Osho Ashram is Pune’s international hub for inner healing and mindfulness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular weekend getaway just outside Pune, offering serene lakeside views and breezy weather. It supplies water to the city and provides a scenic backdrop for picnics and evening drives. Visitors enjoy street food stalls and photography near the lake. Khadakwasla is Pune’s peaceful escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s Korakuen Garden, is a beautifully landscaped park in Sinhagad Road. With its flowing streams, manicured lawns, and traditional Japanese design, it offers a tranquil environment for nature lovers. Families and couples stroll along its bridges and pathways. It symbolizes Pune’s connection to global harmony and natural beauty."
  }
],



  "services": [
    {
      "name": "24 Seater Bus for Rent in Pune",
      "description": "24 Seater Bus for Rent in Pune offers spacious and reliable buses suitable for group travel, corporate outings, school trips, and events. The buses are well-maintained, ensuring safety and comfort for every passenger. Equipped with comfortable seating and ample luggage space, this service is ideal for local city travel as well as longer journeys. Professional drivers ensure punctuality and smooth rides on Pune’s roads, making this an excellent choice for groups needing dependable transportation with hassle-free booking and flexible rental durations."
    },
    {
      "name": "24 Seater AC Bus Pune",
      "description": "24 Seater AC Bus Pune provides air-conditioned buses that guarantee a comfortable and cool travel experience even during Pune’s warm climate. This service caters to corporate clients, tourists, and large family groups who seek premium transportation. The buses feature modern interiors, adjustable seats, and powerful AC systems to maintain optimal comfort throughout the journey. Drivers are experienced and trained to navigate efficiently while maintaining passenger safety. Whether for business travel, tours, or events, this service ensures a luxurious and stress-free ride."
    },
    {
      "name": "24 Seater Non AC Bus Pune",
      "description": "24 Seater Non AC Bus Pune offers economical and well-maintained buses for customers looking for affordable group transportation without air conditioning. Ideal for short-distance travel, school excursions, and local events, these buses provide spacious seating and safe travel conditions. The vehicles undergo regular maintenance to ensure reliability, and drivers are courteous and professional. This service is perfect for budget-conscious groups who still want comfortable and secure transport across Pune and nearby areas."
    },
    {
      "name": "24 Seater Luxury Bus Pune",
      "description": "24 Seater Luxury Bus Pune combines elegance with functionality by offering high-end buses equipped with premium interiors, plush seating, and entertainment options. Designed for VIP guests, corporate executives, and special events, these luxury buses provide an unmatched travel experience. Features include spacious legroom, modern suspension for smooth rides, and onboard amenities to keep passengers comfortable throughout the trip. Chauffeurs are trained in professionalism and discretion, ensuring that every journey is seamless and impressive."
    },
    {
      "name": "24 Seater Mini Bus Hire Pune",
      "description": "24 Seater Mini Bus Hire Pune specializes in renting compact yet spacious mini buses suitable for small to medium-sized groups. This service is ideal for city tours, shuttle services, and corporate outings where maneuverability and efficiency are essential. The mini buses are fuel-efficient, well-maintained, and driven by skilled chauffeurs who prioritize safety and timely arrivals. Flexible rental packages and easy booking make this an accessible option for a variety of travel needs within Pune."
    },
    {
      "name": "24 Seater Bus Rental Hadapsar",
      "description": "24 Seater Bus Rental Hadapsar serves the Hadapsar area with reliable and prompt bus rental services tailored to meet the transport demands of local residents and businesses. The service ensures punctual pickups and drop-offs for school trips, corporate events, and group tours. Vehicles are regularly cleaned and maintained to high standards, and drivers are familiar with the local routes, traffic conditions, and safety protocols. Customer satisfaction is a priority, with easy booking options and affordable pricing."
    },
    {
      "name": "24 Seater Bus Rental Hinjewadi",
      "description": "24 Seater Bus Rental Hinjewadi caters primarily to the IT and corporate hubs of Hinjewadi, providing comfortable and efficient transportation solutions for office commutes, corporate events, and group travel. The buses come equipped with safety features and ample space for passengers and their belongings. This service ensures timely pickups aligned with corporate schedules, making it an ideal choice for businesses that require dependable shuttle services or event transportation in Pune’s tech district."
    },
    {
      "name": "24 Seater Bus Rental Baner",
      "description": "24 Seater Bus Rental Baner offers group transportation services with well-maintained buses ideal for family outings, school trips, and business travel within the Baner area. This service prioritizes safety, comfort, and punctuality to provide a stress-free travel experience. The buses are regularly inspected, and drivers are trained to handle various road conditions safely. Flexible booking options and affordable rates make it convenient for residents and organizations in Baner to access quality bus rental services."
    },
    {
      "name": "24 Seater Bus Rental Pimpri Chinchwad",
      "description": "24 Seater Bus Rental Pimpri Chinchwad serves the industrial and residential zones of Pimpri Chinchwad with efficient group transport solutions. Whether for factory employee transportation, corporate events, or social outings, this service offers reliable and comfortable buses driven by experienced chauffeurs. Regular maintenance ensures vehicle safety and cleanliness, while flexible rental packages allow clients to customize their travel plans. The service supports punctual and smooth rides across the busy industrial corridors and neighborhoods."
    },
    {
      "name": "Affordable 24 Seater Bus Pune",
      "description": "Affordable 24 Seater Bus Pune provides cost-effective bus rental solutions for budget-conscious groups who need spacious and reliable transportation. Without compromising on safety or comfort, this service offers well-maintained buses suitable for school trips, family outings, and community events. Transparent pricing, no hidden charges, and flexible booking durations make this service accessible for various group sizes. Professional drivers ensure timely arrivals and smooth journeys throughout Pune and surrounding areas."
    },
    {
      "name": "24 Seater Bus for Corporate Pune",
      "description": "24 Seater Bus for Corporate Pune specializes in tailored bus rental services for corporate clients, offering dependable transportation for employee shuttles, conferences, and company events. With a focus on professionalism and efficiency, this service ensures timely pickups and drop-offs, clean and comfortable interiors, and discreet, courteous drivers. Corporate clients can avail of flexible contracts and customized billing to suit business needs, making it easier to manage group transportation seamlessly."
    },
    {
      "name": "24 Seater Bus for Wedding Pune",
      "description": "24 Seater Bus for Wedding Pune provides elegant and spacious buses for transporting wedding guests comfortably and on time. The service includes options for decorating buses to match wedding themes, ensuring a stylish and coordinated appearance. Drivers are trained to be punctual and courteous, working closely with event planners to accommodate tight schedules. Whether for local ceremonies or outstation weddings, this service guarantees a smooth, hassle-free travel experience for all attendees."
    },
    {
      "name": "24 Seater Bus for School Trips Pune",
      "description": "24 Seater Bus for School Trips Pune offers safe and reliable buses tailored specifically for transporting students to educational outings, sports events, and excursions. Safety features include seat belts, emergency exits, and regular vehicle inspections. Experienced drivers trained to handle the needs of young passengers accompany every trip. The buses provide comfortable seating and ample space for bags and equipment, ensuring a fun and secure journey for students and teachers alike."
    },
    {
      "name": "24 Seater Bus for Outstation Pune",
      "description": "24 Seater Bus for Outstation Pune offers long-distance bus rentals for group travel outside Pune, including trips to nearby cities and tourist destinations. The buses are designed for comfort during extended journeys, equipped with reclining seats, sufficient legroom, and luggage compartments. Skilled drivers familiar with intercity routes ensure safe and timely travel. Whether for corporate retreats, family vacations, or group tours, this service provides reliable transportation tailored to outstation travel needs."
    },
    {
      "name": "24 Seater Bus Booking Online Pune",
      "description": "24 Seater Bus Booking Online Pune provides a convenient digital platform for customers to reserve buses quickly and effortlessly. The system offers real-time vehicle availability, instant booking confirmation, and multiple payment options. Customers can select specific bus types, rental durations, and pick-up/drop-off locations with ease. Dedicated online support is available 24/7 to assist with inquiries or modifications, ensuring a seamless and modern booking experience tailored to Pune’s diverse group travel requirements."
    },
    {
      "name": "24 Seater Volvo Bus Pune",
      "description": "24 Seater Volvo Bus Pune features premium Volvo buses known for their superior comfort, safety features, and advanced engineering. These buses are ideal for corporate travel, long-distance trips, and luxury group tours. Equipped with plush seating, excellent suspension systems, and modern amenities, Volvo buses ensure a smooth and enjoyable ride. Chauffeurs are specially trained to maintain high standards of service, making this option perfect for clients who demand top-tier travel experiences."
    },
    {
      "name": "24 Seater Tourist Coach Pune",
      "description": "24 Seater Tourist Coach Pune specializes in providing buses designed for sightseeing and tourism, with large windows, comfortable seats, and knowledgeable drivers. This service caters to tourists exploring Pune’s cultural sites, nature spots, and nearby attractions. The coaches offer ample luggage space and can be customized with audio guides or other amenities. Drivers often assist with itinerary planning and local insights, making every tour informative and enjoyable for travelers."
    },
    {
      "name": "24 Seater Bus Hire near Me Pune",
      "description": "24 Seater Bus Hire near Me Pune ensures quick and local access to spacious bus rentals wherever you are in Pune. Leveraging a network of strategically positioned vehicles, this service provides rapid response times and flexible pick-up options. Ideal for last-minute bookings, daily group commutes, or urgent transport needs, it offers reliable and safe buses driven by professional chauffeurs. Customer convenience and satisfaction are central, making this a go-to option for accessible group transportation."
    }
  ],
  "tableData": [
    ["24 Seater Bus for Rent in Pune", "24 Seater AC Bus Pune"],
    ["24 Seater Non AC Bus Pune", "24 Seater Luxury Bus Pune"],
    ["24 Seater Mini Bus Hire Pune", "24 Seater Bus Rental Hadapsar"],
    ["24 Seater Bus Rental Hinjewadi", "24 Seater Bus Rental Baner"],
    ["24 Seater Bus Rental Pimpri Chinchwad", "Affordable 24 Seater Bus Pune"],
    ["24 Seater Bus for Corporate Pune", "24 Seater Bus for Wedding Pune"],
    ["24 Seater Bus for School Trips Pune", "24 Seater Bus for Outstation Pune"],
    ["24 Seater Bus Booking Online Pune", "24 Seater Volvo Bus Pune"],
    ["24 Seater Tourist Coach Pune", "24 Seater Bus Hire near Me Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "24 Seater Bus for Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers spacious and comfortable 24 seater buses for rent in Pune, perfect for group travel and corporate outings."
  },
  {
    "WhyChooseheading": "Well-Maintained and Safe Buses",
    "WhyChoosedescription": "Our 24 seater buses undergo regular maintenance and safety checks to ensure a smooth and secure journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive rental rates with clear, upfront pricing including all taxes and fees—no hidden costs."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, and long-term rental options designed to suit your group’s specific travel needs."
  },
  {
    "WhyChooseheading": "Experienced and Friendly Drivers",
    "WhyChoosedescription": "Our professional drivers prioritize your comfort and safety, providing courteous and punctual service."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, queries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy Booking Process",
    "WhyChoosedescription": "Book your 24 seater bus quickly and conveniently online or via phone with prompt vehicle delivery anywhere in Pune."
  },
  {
    "WhyChooseheading": "Commitment to Customer Satisfaction",
    "WhyChoosedescription": "At Amruta Travels Pvt Ltd, we aim to provide reliable, efficient, and hassle-free group travel experiences in Pune."
  }
]


























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 24 seater bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides reliable 24 seater bus rentals in Pune, ideal for group travel, corporate events, and tours.',
  },
  {
    question: 'How can I book a 24 seater bus for rent in Pune with Amruta Travels?',
    answer: 'You can book a 24 seater bus easily through our website, mobile app, or by contacting our 24x7 customer support in Pune.',
  },
  {
    question: 'What types of buses are available under the 24 seater bus rental in Pune?',
    answer: 'Amruta Travels offers well-maintained 24 seater buses equipped with comfortable seating and modern amenities for a smooth journey.',
  },
  {
    question: 'Are the drivers experienced for 24 seater bus rentals in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and have extensive experience driving 24 seater buses in Pune.',
  },
  {
    question: 'Can 24 seater buses be rented for corporate events and sightseeing in Pune?',
    answer: 'Yes, our 24 seater buses are perfect for corporate outings, school trips, sightseeing tours, and special occasions in Pune.',
  },
  {
    question: 'Is the 24 seater bus rental service available 24x7 in Pune?',
    answer: 'Yes, Amruta Travels offers round-the-clock 24 seater bus rental services in Pune to suit your travel schedule and needs.',
  },
  {
    question: 'What safety and hygiene measures are followed for 24 seater buses in Pune?',
    answer: 'All our 24 seater buses are sanitized before each trip, and our drivers follow strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What are the payment options for renting a 24 seater bus in Pune?',
    answer: 'We accept multiple payment methods including UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during my 24 seater bus rental in Pune?',
    answer: 'Yes, our dedicated 24x7 customer support team is available to assist you throughout your bus rental journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Patil',
    feedback: 'The 24 seater bus rented from Amruta Travels in Pune was very comfortable and clean. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Excellent service by Amruta Travels for our group trip in Pune. The 24 seater bus was spacious and the booking process was hassle-free.',
    rating: 5,
  },
];



























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "24 Seater Bus for Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/1.jpg",
  "description": "Book a 24 Seater Bus for Rent in Pune with Amruta Travels Pvt. Ltd. for comfortable, safe, and affordable travel. Choose from AC, Non-AC, and Luxury buses for corporate trips, weddings, school outings, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "17542"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/24-seater-bus-for-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>24 Seater Bus for Rent in Pune | Luxury, AC & Non-AC Buses | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 24 Seater Bus for Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury buses for corporate travel, weddings, school trips, and outstation journeys at affordable prices."
  />
  <meta
    name="keywords"
    content="24 Seater Bus for Rent in Pune, 24 Seater AC Bus Pune, 24 Seater Non AC Bus Pune, 24 Seater Luxury Bus Pune, 24 Seater Mini Bus Hire Pune, 24 Seater Bus Rental Hadapsar, 24 Seater Bus Rental Hinjewadi, 24 Seater Bus Rental Baner, 24 Seater Bus Rental Pimpri Chinchwad, Affordable 24 Seater Bus Pune, 24 Seater Bus for Corporate Pune, 24 Seater Bus for Wedding Pune, 24 Seater Bus for School Trips Pune, 24 Seater Bus for Outstation Pune, 24 Seater Bus Booking Online Pune, 24 Seater Volvo Bus Pune, 24 Seater Tourist Coach Pune, 24 Seater Bus Hire near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr img-flud">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twentyfourseaterbusforrentinpune;